var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 64,
    viewBox: "0 0 71 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4217 22.1599L32.0243 0L48.2162 20.9656L71 12.6874L57.7059 34.8408L70.5791 47.5249L47.0279 50.1151L44.9234 64L32.5715 51.5859L5.67249 62.6431L17.9143 41.1308L0 24.3661L23.4217 22.1599Z",
    fill: "#FED300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4216ab4d0313963eb5e108c80b6b25ba.svg";
export { ForwardRef as ReactComponent };